module.exports = __webpack_public_path__ + "img/GYLFW_8.bd3093bc.jpg";